module.exports = __webpack_public_path__ + "img/EvolutionSystem.69788081.png";